import React, { createContext, useContext, useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  Paper,

} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { ReactComponent as GenerateDocumentIcon } from "../../../images/APIGenerateDocumentIcon .svg";
import { ReactComponent as DownloadIcon } from "../../../images/DownloadIcon.svg";
import yaml from "js-yaml";
import APIDocPopup from "./APIDocPopup";
import MessagePopup from "../../popup-components/MessagePopup";
import { htmlParsingForSwagger, swaggerToPostman, generateTestCasesForAPI, APITraceabilityMatrix,WebScrappingWebPortal } from "../../../services/webServices";
import { handleProgressBar } from "../../custom-components/ProgressBar/ProgressBarWithAPI";
import { LoadingModalContext } from "../../main-pages/ServicePage";


const WebScrappingForWebPortal = () => {

  const [apiurl, setApiUrl] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const { setLoadingState } = useContext(LoadingModalContext);
  const [openAPISpec, setOpenAPISpec] = useState(null);
  const [openAPIDocPopup, setOpenAPIDocPopup] = useState(false);
  const [responseParsedData, setResponseParsedData] = useState(null);
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  function flattenPostmanItems(items) {
    const flat = [];

    function recurse(subItems) {
      subItems.forEach(item => {
        if (item.request) {
          flat.push(item); // it's a request
        } else if (item.item && item.item.length > 0) {
          recurse(item.item); // it's a folder
        }
      });
    }

    recurse(items);
    return flat;
  }

  const handleGenerateOpenAPISpec = async () => {
    let progressHandler;
    try {
      progressHandler = handleProgressBar({ setLoadingState, totalDurationMs: 9000 });
      progressHandler.start("Generating API Document");
      const response = await WebScrappingWebPortal({ url: apiurl });
      await progressHandler.finishAndClose();

      if (response && response.data) {
        setResponseParsedData(response.data);
        setOpenAPISpec(response.data.spec);
        setOpenAPIDocPopup(true)

      }

    } catch (error) {
      console.error("Error generating OpenAPI spec:", error);
      setLoadingState({ open: false, message: "", progress: null });
      setPopupMessage("Error generating OpenAPI spec. Please check the API URL and try again.");
      setPopupOpen(true);
    } finally {
      console.log("done"); // Reset the input field after processing
      if (progressHandler) {
        progressHandler.stop();
      }
      setLoadingState({ open: false, message: "", progress: null });
    }
  }

  const handleGenerateTestCases = async () => {
    let progressHandler;
    try {
      let tcCounter = 1;
      const finalArray = [];
      let traceabilityMatrix = null;
      // const responseParsedData = await htmlParsingForSwagger({ url: apiurl });
      // if (responseParsedData && responseParsedData.data) {
      //   console.log("Parsed Data:", responseParsedData.data);
      //   // Handle the parsed data as needed
      //   setOpenAPISpec(responseParsedData.data.spec);
      progressHandler = handleProgressBar({ setLoadingState, totalDurationMs: 420000 })

      const responsePostmanCollection = await swaggerToPostman(openAPISpec);
      if (responsePostmanCollection.data.item) {
        const flattenedItems = flattenPostmanItems(responsePostmanCollection.data.item);
        if (flattenedItems.length == 1) {
          progressHandler.start("Generating Test Cases");
        }
        else {
          progressHandler.start("Generating Test Cases for Postman Folder 1");
        }

        const promises = flattenedItems.map(async (item, index) => {
          progressHandler.updateMessage(`Generating Test Cases for Postman Folder ${index + 1}`);
          try {
            const testcasesresponse = await generateTestCasesForAPI(item);

            if (testcasesresponse.data && testcasesresponse.data.testcases) {
              //   const updatedTestCases = testcasesresponse.data.testcases.map((testcase) => {
              //     const isFunctional = testcase.Category?.toLowerCase() === "functional testing";
              //     const subCategory = testcase["Sub-Category"]?.toLowerCase() || "";

              //     let prefix = isFunctional ? "TCD_FT" : "TCD_NFT";
              //     let shortCode = "";

              //     if (subCategory.includes("positive")) shortCode = "POS";
              //     else if (subCategory.includes("negative")) shortCode = "NEG";
              //     else if (subCategory.includes("boundary")) shortCode = "BOUND";
              //     else if (subCategory.includes("error")) shortCode = "ERR";
              //     else if (subCategory.includes("security")) shortCode = "SEC";
              //     else if (subCategory.includes("performance")) shortCode = "PERF";

              //     const padded = String(tcCounter).padStart(2, "0");
              //     const id = `${prefix}_${padded}_${shortCode}`;
              //     tcCounter++;

              //     return {
              //       ...testcase,
              //       "Test Case ID": id,
              //     };
              //   });

              //   finalArray.push(...updatedTestCases);
              // }
              return testcasesresponse.data.testcases;

            }
          } catch (error) {
            console.log(
              error?.response?.data?.error || error.message,
              "Error processing swagger item:", index
            );
          }
          return [];
        }
        );
        const results = await Promise.allSettled(promises);
        for (const result of results) {
          if (result.status === "fulfilled" && Array.isArray(result.value)) {
            const updated = result.value.map((testcase) => {
              const isFunctional = testcase.Category?.toLowerCase() === "functional testing";
              const subCategory = testcase["Sub-Category"]?.toLowerCase() || "";

              let prefix = isFunctional ? "TCD_FT" : "TCD_NFT";
              let shortCode = "";

              if (subCategory.includes("positive")) shortCode = "POS";
              else if (subCategory.includes("negative")) shortCode = "NEG";
              else if (subCategory.includes("boundary")) shortCode = "BOUND";
              else if (subCategory.includes("error")) shortCode = "ERR";
              else if (subCategory.includes("security")) shortCode = "SEC";
              else if (subCategory.includes("performance")) shortCode = "PERF";

              const padded = String(tcCounter).padStart(2, "0");
              const id = `${prefix}_${padded}_${shortCode}`;
              tcCounter++;

              return {
                ...testcase,
                "Test Case ID": id,
              };
            });

            finalArray.push(...updated);
          }
        }


        const filteredTestCases = finalArray.map((testcase) => ({
          "Test Case ID": testcase["Test Case ID"],
          "API Endpoint": testcase["API Endpoint"],
          "Method": testcase["Method"],
          "Test Description": testcase["Test Description"],
          "Category": testcase["Category"],
        }));

        try {
          progressHandler.updateMessage("Generating Traceability Matrix");
          const response = await APITraceabilityMatrix(filteredTestCases);
          if (response.data !== null) {
            traceabilityMatrix = response.data;
          }
        } catch (error) {
          console.log(
            error?.response?.data?.error || error.message,
            "Error generating traceability matrix"
          );
          setPopupMessage("Error generating traceability matrix. Please try again.");
          setPopupOpen(true);
        }

        await progressHandler.finishAndClose();
        navigate("/dashboard/api-testing/manual", {
          state: {
            ...location.state,
            generateTestCasesData: finalArray,
            apiDocData: openAPISpec || null,
            button: "urlHTMLSwaggerParser",
            traceabilityMatrix: traceabilityMatrix,
          },
        });


      }
    } catch (error) {
      console.error("Error generating test cases:", error);
      setLoadingState({ open: false, message: "", progress: null });
      setPopupMessage("Something went wrong while generating test cases.");
      setPopupOpen(true);
    } finally {
      console.log("done"); // Reset the input field after processing
      if (progressHandler) {
        progressHandler.stop();
        setLoadingState({ open: false, message: "", progress: null });
      }
    }
  }

  const handleDownloadAPIDocument = (openAPISpec) => {
    if (!openAPISpec) return;

    try {
      const yamlString = yaml.dump(openAPISpec);
      const blob = new Blob([yamlString], { type: "text/yaml" });
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "openapi-document.yaml";
      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error converting OpenAPI document to YAML:", error);
    }
  };


  return (

    <Box sx={{ padding: 2, borderRadius: 1, width: "100%", }}>
        <Typography variant="subtitle1" sx={{color:"#808080", mb:3}}>Connect to popular API documentation websites and automatically extract endpoint information</Typography>
      <Box sx={{  justifyContent: "space-between", alignItems: "center", mb: 6 }}>
        <Typography variant="subtitle1" fontSize={14} mb={1} fontWeight="bold">API Documentation URL</Typography>
        <TextField
          label="URL"
          variant="outlined"
          fullWidth
          value={apiurl}
          onChange={(e) => setApiUrl(e.target.value)}
          placeholder="Enter URL"
        >

        </TextField>
      </Box>
      <Box sx={{ p: 2, borderRadius: 2, mb: 3, bgcolor: "#FAFAFA" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mr: 3,
          }}
        >
          <Typography
            variant="subtitle1"
            fontWeight={"bold"}
            sx={{ fontSize: "" }}
          >
            Generate API Document
          </Typography>
          <Box sx={{ display: "flex", gap: 5 }}>
            <Button
              variant="outlined"
              sx={{ textTransform: "none", minWidth: "50px", mr: -3 }}
              onClick={handleGenerateOpenAPISpec}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <GenerateDocumentIcon width={15} height={15} />
                <Typography sx={{ fontSize: "", color: "#49A3FF" }}>
                  Generate
                </Typography>
              </Box>
            </Button>
            <Button
              variant="outlined"
              sx={{ textTransform: "none", minWidth: "50px", mr: -3 }}
              // onClick={handleTestConnection}
              onClick={() => handleDownloadAPIDocument(openAPISpec)}
              //
              disabled={!openAPISpec}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <DownloadIcon width={15} height={15} />
                <Typography sx={{ fontSize: "", color: "#49A3FF" }}>
                  Download
                </Typography>
              </Box>
            </Button>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{ display: "flex", justifyContent: "flex-end", mt: 2, mb: 0 }}
        borderTop={"1px solid #C6C6C6"}
        padding={2}
      >

        <Button
          variant="contained"
          // startIcon={<GenerateButtonIcon />}

          sx={{
            textTransform: "none",
            backgroundColor: "#49A3FF",
            color: "white",
            float: "right"
          }}
          onClick={handleGenerateTestCases}
          disabled={!openAPISpec}
        >
          Generate Test Cases
        </Button>
      </Box>
      <APIDocPopup
        open={openAPIDocPopup}
        handleClose={() => setOpenAPIDocPopup(false)}
      />
      <MessagePopup
        modalOpen={popupOpen}
        message={popupMessage}
        okayHandler={() => setPopupOpen(false)}
      />
    </Box>

  );

};
export default WebScrappingForWebPortal;